<template>
  <v-card>
    <v-toolbar dense color="primary" dark>
      <v-spacer></v-spacer>
      <v-toolbar-title>Menu</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('close')">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-list>
      <v-list-tile :to="'/in-game/' + $route.params.game + '/companies'">
        <v-list-tile-action>
          <v-icon>supervisor_account</v-icon>
        </v-list-tile-action>
        <v-list-tile-title>{{$t('inGame.companies.companies')}}</v-list-tile-title>
      </v-list-tile>

      <v-list-tile :to="'/in-game/' + $route.params.game + '/graph'">
        <v-list-tile-action>
          <v-icon>linear_scale</v-icon>
        </v-list-tile-action>
        <v-list-tile-title>{{$t('inGame.supplychainGraph')}}</v-list-tile-title>
      </v-list-tile>

      <v-list-tile :to="'/in-game/' + $route.params.game + '/resume'">
        <v-list-tile-action>
          <v-icon>grid_on</v-icon>
        </v-list-tile-action>
        <v-list-tile-title>{{$t('inGame.resume.resume')}}</v-list-tile-title>
      </v-list-tile>
      <v-list-tile :to="'/in-game/' + $route.params.game + '/orders'">
        <v-list-tile-action>
          <v-icon>bar_chart</v-icon>
        </v-list-tile-action>
        <v-list-tile-title>{{$t('inGame.orders')}}</v-list-tile-title>
      </v-list-tile>
      <v-list-tile :to="'/in-game/' + $route.params.game + '/cost'">
        <v-list-tile-action>
          <v-icon>bar_chart</v-icon>
        </v-list-tile-action>
        <v-list-tile-title>{{$t('inGame.costs')}}</v-list-tile-title>
      </v-list-tile>
      <v-list-tile :to="'/in-game/' + $route.params.game + '/stock'">
        <v-list-tile-action>
          <v-icon>bar_chart</v-icon>
        </v-list-tile-action>
        <v-list-tile-title>{{$t('inGame.stockRemains')}}</v-list-tile-title>
      </v-list-tile>
      <v-list-tile :to="'/in-game/' + $route.params.game + '/buffers'" v-if="currentGame.gameVersion.dd">
        <v-list-tile-action>
          <v-icon>bar_chart</v-icon>
        </v-list-tile-action>
        <v-list-tile-title>{{$t('inGame.buffers')}}</v-list-tile-title>
      </v-list-tile>
      

      <v-list-group no-action>
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>shopping_cart</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Demandes</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
        <v-list-tile v-for="company in demands" :key="company.id" :to="'/in-game/' + $route.params.game + '/demands/' + company._id">
          <v-list-tile-content>
            <v-list-tile-title>{{ company.name }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list-group>

      <v-list-tile :to="'/in-game/' + $route.params.game + '/params'">
        <v-list-tile-action>
          <v-icon>build</v-icon>
        </v-list-tile-action>
        <v-list-tile-title>{{$t('gameVersions.params')}}</v-list-tile-title>
      </v-list-tile>

      <v-list-tile :to="'/in-game/' + $route.params.game + '/reports'">
        <v-list-tile-action>
          <v-icon>picture_as_pdf</v-icon>
        </v-list-tile-action>
        <v-list-tile-title>{{$t('inGame.repport')}}</v-list-tile-title>
      </v-list-tile>

    </v-list>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  props: {
    game: Object
  },
  data() {
    return {};
  },
  computed: {
    demands () {
      return this.game ? this.game.companies.filter((company) => company.simulatedCompany) : [] 
    },

    ...mapGetters('games', {
      currentGame: 'current'
    })
  }
};
</script>